<template>
  <v-card class="mx-auto" tile>
    <v-list nav dense>
      <v-subheader
        ><span class="font-weight-bold">PIÈCES À FOURNIR</span
        ><span class="font-italic"
          ><span v-if="modeEdition">Seuls les fichiers PDF sont autorisés</span>
          - <span class="font-weight-bold">X</span> si obligatoire.
        </span>
      </v-subheader>
      <v-divider></v-divider>
      <v-list-item v-for="(piece, index) in piecesAFournir" :key="index">
        <v-list-item-content class="mt-0 pt-0 mb-0 pb-0">
          <v-list-item-title v-if="modeEdition">
            <v-row>
              <v-col cols="12" md="8" :class="getStyleIsPieceDejaVersee(index)">
                <v-file-input
                  v-if="piece.obligatoire"
                  v-model="fichiersPieces[index]"
                  accept=".pdf"
                  :hint="piece.libelle"
                  persistent-hint
                  prepend-icon="mdi-attachment"
                  dense
                  prepend-inner-icon="mdi-alpha-x"
                  :autofocus="index === 0"
                ></v-file-input>
                <v-file-input
                  v-else
                  v-model="fichiersPieces[index]"
                  accept=".pdf"
                  :hint="piece.libelle"
                  persistent-hint
                  prepend-icon="mdi-attachment"
                  dense
                  :autofocus="index === 0"
                ></v-file-input>
              </v-col>
              <v-col cols="12" md="4">
                <v-btn
                  :disabled="!fichiersPieces[index]"
                  small
                  color="normal"
                  @click="uploadPiece(index)"
                  :loading="loadingUpload[index]"
                >
                  <span v-if="isPieceDejaVersee(index)"
                    ><v-icon left>mdi-upload</v-icon>RE-téléverser
                  </span>
                  <span v-else
                    ><v-icon left>mdi-upload</v-icon>Téléverser
                  </span>
                </v-btn>
              </v-col>
            </v-row>
          </v-list-item-title>
          <v-list-item-title v-else
            ><v-icon v-if="piece.obligatoire" left>mdi-alpha-x</v-icon>
            {{ piece.libelle }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import ApiEtudiantRepository from "@/repositories/ApiEtudiantRepository";
export default {
  name: "DepotPieces",
  props: ["idFormation", "modeEdition", "piecesAFournir"],

  data() {
    return {
      loadingUpload: [],
      fichiersPieces: [],
      idsTypesPieces: [],
      // 15MB
      maxSizeUpload: 15728640
    };
  },
  async created() {
    if (this.idFormation) {
      await this.getPiecesEtudiant(this.idFormation);
    }
  },
  methods: {
    async getPiecesEtudiant(idFormation) {
      try {
        const pieces = await ApiEtudiantRepository.getMesPiecesEtudiantFormation(
          idFormation
        );
        for (let piece of pieces) {
          this.idsTypesPieces.push(piece.idType);
        }
        this.$emit("majPiecesEtu", this.idsTypesPieces);
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    isPieceDejaVersee(index) {
      return this.idsTypesPieces.indexOf(this.piecesAFournir[index].id) < 0
        ? false
        : true;
    },
    getStyleIsPieceDejaVersee(index) {
      return this.idsTypesPieces.indexOf(this.piecesAFournir[index].id) < 0
        ? this.piecesAFournir[index].obligatoire
          ? "blue-grey lighten-1"
          : "blue-grey lighten-3"
        : "";
    },
    async uploadPiece(index) {
      const piece = this.getPieceParIndex(index);
      await this.depotPiece(piece.id, this.fichiersPieces[index], index);
      this.$set(this.fichiersPieces, index, null);
    },
    getPieceParIndex(index) {
      return this.piecesAFournir[index];
    },
    async depotPiece(idTypePiece, fichier, index) {
      if (fichier.type !== "application/pdf") {
        this.$toast.error("Seuls les fichiers PDF sont acceptés");
        return;
      }
      if (fichier.size > this.maxSizeUpload) {
        this.$toast.error(
          "Le fichier est trop gros (maximum " +
            this.maxSizeUpload / 1024 / 1024 +
            "MB)"
        );
        return;
      }
      this.$set(this.loadingUpload, index, true);
      let formData = new FormData();
      formData.append("fichierPiece", fichier);
      try {
        await ApiEtudiantRepository.depotPieceEtudiant(
          idTypePiece,
          this.idFormation,
          formData
        );
        this.$emit("depot");
        this.$toast.success("Le fichier a bien été téléversé");
        this.idsTypesPieces.push(idTypePiece);
        this.$emit("majPiecesEtu", this.idsTypesPieces);
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      } finally {
        this.$set(this.loadingUpload, index, false);
      }
    }
  }
};
</script>
